export default function FitDiagram({ label, sw, sh, pw, ph, ok, testid }) {
  const k = 150 / Math.max(sw, sh, pw, ph);
  const SW = sw * k, SH = sh * k, PW = pw * k, PH = ph * k;
  const base = Math.max(SH, PH) + 10;
  const c = ok ? "#10b981" : "#ef4444";
  return (
    <figure data-testid={testid} className="flex-1 min-w-[150px]">
      <svg viewBox={`0 0 ${Math.max(SW, PW) + 20} ${base + 10}`} className="w-full h-40">
        <rect x="10" y={base - SH} width={SW} height={SH} fill="none" stroke="#00f0ff" strokeDasharray="5 4" strokeWidth="1.5" />
        <rect x={10 + Math.max(0, (SW - PW) / 2)} y={base - PH} width={PW} height={PH} fill={c} fillOpacity=".3" stroke={c} strokeWidth="2" rx="2" />
      </svg>
      <figcaption className="text-[11px] text-slate-400 text-center">{label}</figcaption>
    </figure>
  );
}
